import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import { PaymentListResponse, PaymentsPayload, ExportPaymentResponse } from '../models/payment';

export const onGetPayments = async (payload: PaymentsPayload) => {
	try {
		const response = await axios.get<JsonResponse<PaymentListResponse>>('dashboard/payment-invoices', {
			params: { ...payload },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onExportPaymentInvoice = async (id: number) => {
	try {
		const response = await axios.get<JsonResponse<ExportPaymentResponse | null>>(`dashboard/payment-invoices/${id}/pdf`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
